<template>
  <div :class="[`p-h-container--${marginSize}`]">
    <slot name="content" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
@Options({
  props: {
    marginSize: { type: String, default: "l" }
  }
})
export default class HContainer extends Vue {
  marginSize!: string;
}
</script>

<style lang="scss">
.p-h-container {
  &--l {
    margin-top: rem(20) !important;
  }

  &--m {
    margin-top: rem(16) !important;
  }

  &--s {
    margin-top: rem(8) !important;
  }

  &--xs {
    margin-top: rem(4) !important;
  }
}
</style>
